import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { computed } from "vue";
import {} from "@/api/invocations";
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import { withPrefix } from "@/utils/redirect";
import ExternalLink from "../ExternalLink.vue";
import HelpText from "../Help/HelpText.vue";
import InvocationGraph from "../Workflow/Invocation/Graph/InvocationGraph.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import InvocationMessage from "@/components/WorkflowInvocationState/InvocationMessage.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowInvocationOverview',
    props: {
        invocation: null,
        invocationAndJobTerminal: { type: Boolean },
        invocationSchedulingTerminal: { type: Boolean },
        isFullPage: { type: Boolean },
        isSubworkflow: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { workflow, loading, error } = useWorkflowInstance(props.invocation.workflow_id);
        const uniqueMessages = computed(() => {
            const messages = props.invocation.messages || [];
            const uniqueMessagesSet = new Set(messages.map((message) => JSON.stringify(message)));
            return Array.from(uniqueMessagesSet).map((message) => JSON.parse(message));
        });
        return { __sfc: true, props, workflow, loading, error, uniqueMessages, BAlert, withPrefix, ExternalLink, HelpText, InvocationGraph, LoadingSpan, InvocationMessage };
    }
});
